export default "__VITE_ASSET__CV7hF14P__"